<template>
  <v-btn fab fixed bottom right color="primary" @click="isDialogVisible = true">
    <role-dialog
      :showDialog="isDialogVisible"
      :loading="loading"
      @close="closeDialog"
      @submit="saveRole"
      v-if="isDialogVisible"
    />
    <v-icon>mdi-plus</v-icon>
  </v-btn>

</template>

<script>
import RoleDialog from './RoleDialog';
import { mapActions } from 'vuex';

export default {
  components: { RoleDialog },
  data: () => ({
    isDialogVisible: false,
    loading: false,
  }),
  methods: {
    ...mapActions('whizeosupportToolsStore', ['SHOW_SNACKBAR']),
    ...mapActions('roles', {saveRoleStore: 'saveRole'}),
    clearForm() {
      this.name = '';
      this.description = '';
      this.permissionId = [];
    },
    closeDialog() {
      this.clearForm();
      this.isDialogVisible = false;
    },
    async saveRole(role) {
      this.loading = true;

      try {
        this.saveRoleStore(role);

        this.closeDialog();
      } catch {
        const errorMessage = {
          visible: true,
          color: 'error',
          message: 'There was a problem while saving the new role.'
        };

        this.SHOW_SNACKBAR(errorMessage);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>